module.exports = __webpack_public_path__ + "static/media/020-Fenster-Nicht-Geschlossen_ID_1.3de0b6c3.mp3";